import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class MosaicErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Production integration hook for monitoring infrastructure telemetry (e.g., Sentry)
    console.error("[Mosaic Boundary] Unhandled Runtime Exception:", error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{
          backgroundColor: "#07070A",
          color: "#FFFFFF",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Outfit', system-ui, sans-serif",
          padding: "24px",
          textAlign: "center"
        }}>
          <div style={{ 
            maxWidth: "460px", 
            border: "1px solid rgba(255,255,255,0.07)", 
            padding: "40px", 
            borderRadius: "3px", 
            background: "#0E0E12" 
          }}>
            <h2 style={{ 
              fontFamily: "'Cormorant Garamond', Georgia, serif", 
              fontSize: "2rem", 
              fontWeight: 300, 
              marginBottom: "12px" 
            }}>
              System Variance Detected
            </h2>
            <p style={{ color: "#C8C8C8", fontSize: "14px", marginBottom: "24px", lineHeight: "1.7" }}>
              We encountered an unhandled optimization issue while initializing the interface layout. The deployment baseline remains operational.
            </p>
            <button 
              type="button"
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: "#C0C0C0",
                color: "#000000",
                border: "none",
                padding: "10px 22px",
                borderRadius: "3px",
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer"
              }}
            >
              Reinitialize Framework
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}